import React, { FC, useEffect, useMemo, useState } from "react";
import { Row, Col, Collapse, Input, Spin, Form } from "antd";
import MemberItems from "@pages/member-details/items";
import { isEmpty, cloneDeep } from "lodash";
import PinUnpin from "@pages/member-details/pin-unpin-component";
import membersService from "@services/members.service";
import memberDetailsService from "@services/memberDetails.service";
import InputMask from "react-input-mask";
import "./coordinator-details.scss";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { CanEdit } from "@components/accessLevel";
import {
  CASE_STATUS_INFORMATION_UPDATE,
  USER_ACTION_MODULE_MEMBER_DETAIL,
  USER_ACTION_TAB_CONTACT_DETAILS,
  USER_ACTION_LOCATION_SAVE_CHANGES,
  USER_ACTION_DESCRIPTION_CONTACT_DETAIL_SAVE,
  USER_ACTION_CARD_CONTACT_INFORMATION,
} from "@utils/constants";
import { formatDisplayDate, formatPhoneNumber } from "@utils/helpers";
import { useContactDetailsForCoordinatorStore } from "@stores/contactDetailsForCoordinatorStore";
import { NO_DATA_FOUND } from "../../../../constants/constants";
import DataNotFound from "@components/noDataFound";

const { Panel } = Collapse;

const CoordinatorDetails: FC<any> = (props) => {
  const dataCardId = "41";
  const [activeCardPanel, setActiveCardPanel] = useState<any>(props?.activeKey?.includes(dataCardId) ? ["1"] : []);
  const [editFlag, setEditFlag] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const contactDetails = useContactDetailsForCoordinatorStore((state) => state.contactDetails);
  const setContactDetails = useContactDetailsForCoordinatorStore((state) => state.setContactDetails);
  const previousContactDetails = useContactDetailsForCoordinatorStore((state) => state.previousContactDetails);
  const setPreviousContactDetails = useContactDetailsForCoordinatorStore((state) => state.setPreviousContactDetails);
  const clearStore = useContactDetailsForCoordinatorStore((state) => state.clearStore);
  const membersServiceGetCurrentMember = membersService?.getCurrentMember;
  const [errorMessage, setErrorMessage] = useState({
    patientMobile: "",
    patientAlternatePhoneNum: "",
    email: "",
    careGiverPhone: ""
  });
  const [form] = Form.useForm();
  const hasErrors = Object.values(errorMessage).some((msg) => msg !== "");

  const getUserActionParams = (userActionDescription: any, reason: any) => {
    let props = {
      caseStatusReasonTxt: reason,
      actionModule: USER_ACTION_MODULE_MEMBER_DETAIL,
      actionTab: USER_ACTION_TAB_CONTACT_DETAILS,
      actionCard: USER_ACTION_CARD_CONTACT_INFORMATION,
      actionLocation: USER_ACTION_LOCATION_SAVE_CHANGES,
      actionDescription: userActionDescription,
    };
    return props;
  };
  const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
    USER_ACTION_DESCRIPTION_CONTACT_DETAIL_SAVE,
    CASE_STATUS_INFORMATION_UPDATE
  );

  useEffect(() => {
    setActiveCardPanel(props?.activeKey?.includes(dataCardId) ? ["1"] : []);
    if (!contactDetails && props?.activeKey?.includes(dataCardId)) {
      getContactDetails(["1"]);
    }
  }, [props?.activeKey]);

  const patientID = useMemo(() => {
    return membersServiceGetCurrentMember?.patient_id;
  }, [membersServiceGetCurrentMember?.patient_id]);

  const getContactDetails = (panelExpanded: any) => {
    if (panelExpanded?.length > 0) {
      setLoading(true);
      memberDetailsService.getContactInfoForCoordinator(patientID).subscribe({
        next: (response) => {
          const data = response?.data?.data;
          const updatedDetails = { ...data };
          setContactDetails(data);
          setPreviousContactDetails(updatedDetails);
          setLoading(false);
        },
        error: (e) => {
          console.log(e);
          setLoading(false);
          setContactDetails(null);
        },
      });
    }
  };

  const onCollapseChange = () => {
    if (activeCardPanel.length > 0) {
      props?.setActivePanels(cloneDeep(props?.activeKey)?.filter((item: any) => item !== dataCardId));
    } else props?.setActivePanels([...(props?.activeKey ? props?.activeKey : []), dataCardId]);
  };

  useEffect(() => {
    if (contactDetails?.patientId?.toString() !== patientID?.toString()) {
      clearStore();
      form.resetFields();
      setErrorMessage({ patientMobile: "", patientAlternatePhoneNum: "", email: "", careGiverPhone: "" });
    }
  }, [patientID]);

  useEffect(() => {
    if (contactDetails) {
      form.setFieldsValue({
        emailId: emptyValueChecker(contactDetails?.patientEmail),
        patientMobile: emptyValueChecker(contactDetails?.patientMobile),
        patientAlternatePhoneNum: emptyValueChecker(contactDetails?.patientAlternatePhoneNum),
        street: emptyValueChecker(contactDetails?.patientStreet),
        city: emptyValueChecker(contactDetails?.patientCity),
        state: emptyValueChecker(contactDetails?.patientState),
        zipCode: emptyValueChecker(contactDetails?.patientZipCode),
        careGiverName: emptyValueChecker(contactDetails?.careGiverName),
        careGiverPhone: emptyValueChecker(contactDetails?.careGiverPhone),
      });
    }
  }, [contactDetails, form]);

  const genExtra = (id: any, editFlag: any, showLoader: any, onCancel: any, onUpdateDetails: any, setEditFlag: any) => {
    return (
      <>
        <div onClick={(e) => e.stopPropagation()} className="editClass">
          <CanEdit>
            {editFlag ? (
              <>
                <Spin spinning={showLoader} indicator={<HealthemSpinner />}>
                  <span
                    style={{ margin: "0 20px" }}
                    className="link clr-n125"
                    onClick={(e) => {
                      e.stopPropagation();
                      onCancel();
                    }}
                  >
                    Cancel
                  </span>
                  <span
                    className="link save-coordinator-info-extra"
                    onClick={(e) => {
                      e.stopPropagation();
                      !hasErrors && onUpdateDetails();
                    }}
                    style={{ cursor: hasErrors ? "not-allowed" : "pointer", opacity: hasErrors ? 0.6 : 1 }}
                  >
                    Save Changes
                  </span>
                </Spin>
              </>
            ) : (
              <>
                <span
                  className="link clr-blueLink edit-alignment"
                  onClick={(e) => {
                    e.stopPropagation();
                    setEditFlag(true);
                  }}
                >
                  <i style={{ verticalAlign: "middle", marginRight: 10 }} className="icon icon-edit"></i>
                  Edit
                </span>
              </>
            )}
          </CanEdit>
        </div>
        <PinUnpin marginRight={"16px"} dataCardId={id} changeHandler={props?.pinChangeHandler} pinCardIds={props.pinCardIds} />
      </>
    );
  };

  const onUpdateDetails = () => {
    setShowLoader(true);
    membersService.updateStatus(membersServiceGetCurrentMember?.patient_id, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription).subscribe({
      next: (v) => {
        console.log("updated status successfully");
      },
      error: (e) => {
        console.log("update status failed for contact information");
      },
    });
    memberDetailsService.submitContactData(patientID, contactDetails).subscribe({
      next: (v) => {
        setShowLoader(false);
        setEditFlag(false);
        setContactDetails(v.data.contactInformation);
        setPreviousContactDetails(v.data.contactInformation);
      },
      error: (e) => {
        setShowLoader(false);
      },
    });
  };

  const onCancel = () => {
    setContactDetails(previousContactDetails);
    setEditFlag(false);
    form.resetFields();
    setErrorMessage({
    patientAlternatePhoneNum: "",
      patientMobile: "",
      email: "",
      careGiverPhone: ""
    });
  };

  const emptyValueChecker = (val: any) => {
    return val !== "--" && !isEmpty(val) ? val : "";
  };

  const handlePhoneNumberChange = (e: any, field: string) => {
    const value = e.target.value;
    setContactDetails({ ...contactDetails, [field]: value });
    const numberOnly = value.replace(/[^\d]/g, "");
    if (!/^\+1 \d{3} \d{3} \d{4}$/.test(value) && numberOnly.length > 1) {
      setErrorMessage((prev) => ({
        ...prev,
        [field]: "Enter valid Phone Number",
      }));
    } else {
      setErrorMessage((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const handleEmailChange = (e: any) => {
    const value = e.target.value;

    setContactDetails({ ...contactDetails, patientEmail: value });
    form
      .validateFields(["emailId"])
      .then(() => {
        setErrorMessage((prev) => ({ ...prev, email: "" }));
      })
      .catch((errorInfo) => {
        const error = errorInfo.errorFields.find((field: any) => field.name.includes("emailId"));
        setErrorMessage((prev) => ({ ...prev, email: error ? error.errors[0] : "" }));
      });
  };

  return (
    <>
      <Collapse accordion expandIconPosition="right" bordered={false} activeKey={activeCardPanel} onChange={onCollapseChange} className={"coordinator-info-container"}>
        <Panel
          header="Contact Details (Updated By Coordinator)"
          key="1"
          className="title"
          extra={genExtra(dataCardId, editFlag, showLoader, onCancel, onUpdateDetails, setEditFlag)}
          style={{ marginBottom: "8px" }}
        >
          {loading ? (
            <Spin spinning={loading} indicator={<HealthemSpinner size={50} />}></Spin>
          ) : contactDetails ? (
            <>
              <Form
                form={form}
                layout="vertical"
                initialValues={{
                  emailId: emptyValueChecker(contactDetails?.patientEmail),
                  patientMobile: emptyValueChecker(contactDetails?.patientMobile),
                  patientAlternatePhoneNum: emptyValueChecker(contactDetails?.patientAlternatePhoneNum),
                  street: emptyValueChecker(contactDetails.patientStreet),
                  city: emptyValueChecker(contactDetails?.patientCity),
                  state: emptyValueChecker(contactDetails?.patientState),
                  zipCode: emptyValueChecker(contactDetails.patientZipCode),
                  careGiverName:emptyValueChecker(contactDetails.careGiverName),
                  careGiverPhone:emptyValueChecker(contactDetails.careGiverPhone)
                }}
              >
                <Row gutter={48}>
                  <Col span={12} style={{ paddingLeft: 0, paddingRight: 0 }}>
                    <Col className="title" span={24} style={{ marginBottom: 16 }}>
                      <span>General</span>
                    </Col>
                    <Col span={24}>
                      <MemberItems
                        left={12}
                        right={12}
                        name="Phone Number"
                        value={
                          editFlag ? (
                            <Form.Item name="patientMobile" validateStatus={errorMessage.patientMobile ? "error" : ""} help={errorMessage.patientMobile || ""}>
                              <InputMask
                                name="patientMobile"
                                mask="+1 999 999 9999"
                                placeholder="+1 000 000 0000" 
                                maskPlaceholder={null}
                                className="ant-input member-item"
                                onChange={(e) => handlePhoneNumberChange(e, "patientMobile")}
                              />
                            </Form.Item>
                          ) : (
                            formatPhoneNumber(contactDetails?.patientMobile, "usFormat")
                          )
                        }
                      />
                    </Col>
                    <Col span={24}>
                      <MemberItems
                        left={12}
                        right={12}
                        name="Alt. Phone Number"
                        value={
                          editFlag ? (
                            <Form.Item name="patientAlternatePhoneNum" validateStatus={errorMessage.patientAlternatePhoneNum ? "error" : ""} help={errorMessage.patientAlternatePhoneNum || ""}>
                              <InputMask placeholder="+1 000 000 0000" name="patientAlternatePhoneNum" mask="+1 999 999 9999" maskPlaceholder={null} className="ant-input member-item" onChange={(e) => handlePhoneNumberChange(e, "patientAlternatePhoneNum")}/>
                            </Form.Item>
                          ) : (
                            contactDetails?.patientAlternatePhoneNum
                          )
                        }
                      />
                    </Col>
                    <Col span={24}>
                      <MemberItems
                        left={12}
                        right={12}
                        name="Email Address"
                        value={
                          editFlag ? (
                            <Form.Item name="emailId" rules={[{ type: "email", message: "Enter valid Email Address" }]} validateStatus={errorMessage.email ? "error" : ""} help={errorMessage.email || ""}>
                              <Input  placeholder="example@example.com" className="member-item" onChange={handleEmailChange} />
                            </Form.Item>
                          ) : contactDetails?.patientEmail === "--" ? (
                            contactDetails?.patientEmail
                          ) : (
                            <a className="mail-to-link" href={`mailto:${contactDetails?.patientEmail}`}>
                              {contactDetails?.patientEmail}
                            </a>
                          )
                        }
                      />
                    </Col>
                    <Col span={24}>
                      <MemberItems
                        left={12}
                        right={12}
                        name="Caregiver Name"
                        value={
                          editFlag ? (
                            <Form.Item name="careGiverName">
                              <Input
                                placeholder="Enter Caregiver Name"
                                className="member-item"
                                value={emptyValueChecker(contactDetails?.careGiverName)}
                                onChange={(e) => setContactDetails({ ...contactDetails, careGiverName: e.target.value })}
                              />
                            </Form.Item>
                          ) : (
                            contactDetails?.careGiverName
                          )
                        }
                      />
                    </Col>
                    <Col span={24}>
                      <MemberItems
                        left={12}
                        right={12}
                        name="Caregiver Phone"
                        value={
                          editFlag ? (
                            <Form.Item name="careGiverPhone" validateStatus={errorMessage.careGiverPhone ? "error" : ""} help={errorMessage.careGiverPhone || ""}>
                              <InputMask placeholder="+1 000 000 0000" name="careGiverPhone" mask="+1 999 999 9999" maskPlaceholder={null} className="ant-input member-item" onChange={(e) => handlePhoneNumberChange(e, "careGiverPhone")} />
                            </Form.Item>
                          ) : (
                            contactDetails?.careGiverPhone
                          )
                        }
                      />
                    </Col>
                  </Col>
                  <Col span={12} style={{ paddingTop: "3px" }}>
                    <Col className="title" style={{ paddingLeft: 0, paddingRight: 0, marginBottom: 16 }}>
                      <span>Address</span>
                    </Col>
                    <Col span={24} className={"col-space-alignment"}>
                      <MemberItems
                        left={12}
                        right={12}
                        name="Street"
                        value={
                          editFlag ? (
                            <Form.Item name="street">
                              <Input
                                 placeholder="Enter Street"
                                className="member-item"
                                value={emptyValueChecker(contactDetails?.patientStreet)}
                                onChange={(e) => setContactDetails({ ...contactDetails, patientStreet: e.target.value })}
                              />
                            </Form.Item>
                          ) : (
                            contactDetails?.patientStreet
                          )
                        }
                      />
                    </Col>
                    <Col span={24} className={"col-space-alignment"}>
                      <MemberItems
                        left={12}
                        right={12}
                        name="City"
                        value={
                          editFlag ? (
                            <Form.Item name="city">
                              <Input
                                 placeholder="Enter City"
                                className="member-item"
                                value={emptyValueChecker(contactDetails?.patientCity)}
                                onChange={(e) => setContactDetails({ ...contactDetails, patientCity: e.target.value })}
                              />
                            </Form.Item>
                          ) : (
                            contactDetails?.patientCity
                          )
                        }
                      />
                    </Col>
                    <Col span={24} className={"col-space-alignment"}>
                      <MemberItems
                        left={12}
                        right={12}
                        name="State / Province"
                        value={
                          editFlag ? (
                            <Form.Item name="state">
                              <Input
                                placeholder="Enter State / Province"
                                className="member-item"
                                value={emptyValueChecker(contactDetails?.patientState)}
                                onChange={(e) => setContactDetails({ ...contactDetails, patientState: e.target.value })}
                              />
                            </Form.Item>
                          ) : (
                            contactDetails?.patientState
                          )
                        }
                      />
                    </Col>
                    <Col span={24} className={"col-space-alignment"}>
                      <MemberItems
                        left={12}
                        right={12}
                        name="Zip Code / Postal Code"
                        value={
                          editFlag ? (
                            <Form.Item name="zipCode">
                              <Input
                                type="text"
                                pattern="[0-9]"
                                className="member-item"
                                value={emptyValueChecker(contactDetails?.patientZipCode)}
                                placeholder="Enter Postal Code"
                                onChange={(e) => 
                                  setContactDetails({
                                    ...contactDetails,
                                    patientZipCode: e.target.value.replace(/[^0-9]/g, ""),
                                  })
                                }
                              />
                            </Form.Item>
                          ) : (
                            contactDetails?.patientZipCode
                          )
                        }
                      />
                    </Col>
                  </Col>
                </Row>
              </Form>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <span className="italic member-key">Last Updated On</span>
                <span className="italic member-value">{!isEmpty(contactDetails?.updatedOn) ? formatDisplayDate(contactDetails?.updatedOn, "createDateFormat") : "--"}</span>
              </div>
            </>
          ) : (
            <DataNotFound message={NO_DATA_FOUND} />
          )}
        </Panel>
      </Collapse>
    </>
  );
};

export default CoordinatorDetails;
